import { render, staticRenderFns } from "./TopicAssistant.vue?vue&type=template&id=ea4447c4&"
import script from "./TopicAssistant.vue?vue&type=script&lang=js&"
export * from "./TopicAssistant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports